import { useNavigate } from 'react-router';
import { startTransition, useState } from 'react';
import { MonitorSmartphone, MonitorCheck, Frown, Smile } from 'lucide-react';

import { Button } from 'src/components/ui/button';
import { ErrorHero } from 'src/components/ui/error-hero';
import env from 'env';

const NotFound = () => {
  const [isHappy, setIsHappy] = useState(false);
  const navigate = useNavigate();

  const onGoHome = () => startTransition(() => navigate('/'));

  const onContactSupport = () => window.open(`mailto:${env.CODEKEEPER_SERVICE_EMAIL}`);

  const onToggleHappy = () => setIsHappy((prev) => !prev);

  return (
    <div className="min-h-screen flex items-center justify-center py-10 px-6">
      <div className="container mx-auto">
        <div className="grid md:grid-cols-2 items-center gap-8 md:gap-16">
          <div className="space-y-8">
            <h1 className="text-3xl md:text-5xl font-bold text-foreground md:leading-14">
              The page you&apos;re trying to reach doesn&apos;t exist.
            </h1>
            <div className="flex gap-3">
              <Button
                variant="default"
                size="lg"
                onClick={onGoHome}
                onMouseEnter={onToggleHappy}
                onMouseLeave={onToggleHappy}
              >
                Go back home
              </Button>
              <Button
                variant="secondary"
                size="lg"
                onClick={onContactSupport}
                onMouseEnter={onToggleHappy}
                onMouseLeave={onToggleHappy}
              >
                Contact support
              </Button>
            </div>
          </div>
          <ErrorHero
            headerTitle="Error 404"
            errorCode="404"
            leftIcon={isHappy ? MonitorCheck : MonitorSmartphone}
            rightIcon={isHappy ? Smile : Frown}
          />
        </div>
      </div>
    </div>
  );
};

export default NotFound;
